import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Contact = () => {
	const formRef = useRef();
	const [form, setForm] = useState({
		name: "",
		email: "",
		message: "",
	});


	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		const { target } = e;
		const { name, value } = target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);

		// cleaning the form data
		const username = form.name.trim();
		const user_email = form.email.trim();
		const user_message = form.message.trim();

		if (username === '' || user_email === '' || user_message === '') {
			setLoading(false);
			toast.error("Please fill all the fields.", {
				position: 'bottom-right',
			});
			return;
		}
		console.log(username, user_email, user_message);

		emailjs
			.send(
				'service_z4k5157',
				'template_r7nypba',
				{
					from_name: username,
					to_name: "Abhay Varshney",
					reply_to: user_email,
					to_email: "abhay25v@gmail.com",
					message: user_message,
				},
				{publicKey: 'pHAMif6FY61HuMRtV'}
			)
			.then(
				() => {
					setLoading(false);
					toast.success("Message sent successfully!", {
						position: 'bottom-right',
					});
					setForm({
						name: "",
						email: "",
						message: "",
					});
				},
				(error) => {
					setLoading(false);
					console.error(error);
					toast.error("Uh, oh! Something went wrong. Please try again later.", {
						position: 'bottom-right',
					});
				}
			);
	};

	return (
		<section id='contact' className='relative z-0 w-screen min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black scroll-mt-24'>
			<div className='text-white overflow-x-hidden pt-28 pb-16 px-4'>
				<div className='z-10 w-full max-w-xl mx-auto rounded-2xl border border-slate-800 bg-slate-900/70 p-8 shadow-[0_18px_45px_rgba(15,23,42,0.9)] reveal-on-scroll'>
					<p className='text-xs font-medium uppercase tracking-[0.3em] text-sky-400/80'>
						Contact
					</p>
					<h2 className='mt-2 text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-sky-300 via-teal-300 to-emerald-300'>
						Let's connect
					</h2>
					<p className='mt-3 text-sm text-slate-300'>
						Have an idea, opportunity, or question? Drop a message and I'll get back to you as soon as I can.
					</p>
					<form
						ref={formRef}
						onSubmit={handleSubmit}
						className='mt-10 flex flex-col gap-6'
					>
						<label className='flex flex-col gap-2 text-sm'>
							<span className='font-medium text-slate-200'>Your Name</span>
							<input
								type='text'
								name='name'
								value={form.name}
								onChange={handleChange}
								placeholder="Enter your name"
								className='rounded-lg border border-slate-700 bg-slate-950/60 px-4 py-3 text-sm text-slate-100 outline-none focus:border-sky-400 focus:ring-1 focus:ring-sky-500'
								required
							/>
						</label>
						<label className='flex flex-col gap-2 text-sm'>
							<span className='font-medium text-slate-200'>Your Email</span>
							<input
								type='email'
								name='email'
								value={form.email}
								onChange={handleChange}
								placeholder="you@example.com"
								className='rounded-lg border border-slate-700 bg-slate-950/60 px-4 py-3 text-sm text-slate-100 outline-none focus:border-sky-400 focus:ring-1 focus:ring-sky-500'
								required
							/>
						</label>
						<label className='flex flex-col gap-2 text-sm'>
							<span className='font-medium text-slate-200'>Your Message</span>
							<textarea
								rows={6}
								name='message'
								value={form.message}
								onChange={handleChange}
								placeholder='Tell me a bit about what you have in mind...'
								className='rounded-lg border border-slate-700 bg-slate-950/60 px-4 py-3 text-sm text-slate-100 outline-none focus:border-sky-400 focus:ring-1 focus:ring-sky-500'
								required
							/>
						</label>

						<button
							type='submit'
							className='inline-flex items-center justify-center rounded-xl bg-sky-500/90 px-6 py-3 text-sm font-semibold text-slate-950 shadow-lg shadow-sky-500/30 transition-colors duration-200 hover:bg-sky-400 disabled:cursor-not-allowed disabled:opacity-70'
							disabled={loading}
						>
							{loading ? "Sending..." : "Send message"}
						</button>
					</form>
				</div>
				<ToastContainer position="bottom-right" theme="dark" />
			</div>
		</section>
	);
};

export default Contact;